import CryptoJS, { AES, DES, TripleDES, RC4, Rabbit, MD5 } from 'crypto-js'
import { base64ToBase32 } from './Common'

/**
 * @description 支持AES、DES、TripleDES加密
 * @param mode 加密方式(AES、DES, TripleDES)
 * @param value 加密内容
 * @param key 密钥
 * @param inEnc 输入字符编码(Base64、Base64url、Hex、Latin1、Utf16、Utf16BE、Utf16LE、Utf8)
 * @param outEnc 输出字符编码(Base64、Base64url、Hex、Latin1、Utf16、Utf16BE、Utf16LE、Utf8)
 * @param type 加密类型(ECB、CBC、CTR、CTRGladman、OFB、CFB)
 * @param pad 填充模式(AnsiX923、Iso10126、Iso97971、NoPadding、Pkcs7、ZeroPadding)
 * @param iv 偏移量（CBC、CTR、CTRGladman、OFB、CFB模式下必须）
 * @param block 密钥长度（128、192、256）
 */
export function encrypt1(mode, value, key, inEnc, outEnc, type, pad, iv, block = 128) {
  let newKey = key
  // AES需要根据密钥长度截取密钥
  if (mode === 'AES') {
    newKey = key.slice(0, block / 8)
  }
  const modeData = {
    AES,
    DES,
    TripleDES,
  }
  const params = {
    mode: CryptoJS.mode[type],
    padding: CryptoJS.pad[pad]
  }
  if (iv) params.iv = CryptoJS.enc[inEnc].parse(iv)
  const cipherData = modeData[mode].encrypt(value, CryptoJS.enc[inEnc].parse(newKey), params)
  try {
    return CryptoJS.enc[outEnc].stringify(cipherData.ciphertext)
  } catch (error) {
    return value
  }
}
/**
 * @description 支持RC4、Rabbit加密
 * @param mode 加密类型(RC4、Rabbit)
 * @param value 加密内容
 * @param key 密钥
 * @param inEnc 输入字符编码(Base64、Base64url、Hex、Latin1、Utf16、Utf16BE、Utf16LE、Utf8)
 * @param outEnc 输出字符编码(Base64、Base64url、Hex、Latin1、Utf16、Utf16BE、Utf16LE、Utf8)
 */
export function encrypt2(mode, value, key, inEnc, outEnc) {
  const typeData = {
    RC4,
    Rabbit,
  }
  const cipherData = typeData[mode].encrypt(value, CryptoJS.enc[inEnc].parse(key))
  try {
    return CryptoJS.enc[outEnc].stringify(cipherData.ciphertext)
  } catch (error) {
    return value
  }
}
/**
 * @description MD5加密
 * @param value 加密内容
 * @param outEnc 输出字符编码(Hex、Base64、Base64Upper、Base64Lower、Base32、Base32Upper、Base32Lower)
 */
export function encryptMd5(value, outEnc) {
  const cipherData = MD5(value)
  let val = ''
  switch (outEnc) {
    case 'Hex':
      val = cipherData.toString(CryptoJS.enc.Hex)
      break
    case 'Base64Upper':
      val = cipherData.toString(CryptoJS.enc.Base64).toUpperCase()
      break
    case 'Base64Lower':
      val = cipherData.toString(CryptoJS.enc.Base64).toLowerCase()
      break
    case 'Base32':
      val = base64ToBase32(cipherData.toString(CryptoJS.enc.Base64))
      break
    case 'Base32Upper':
      val = base64ToBase32(cipherData.toString(CryptoJS.enc.Base64)).toUpperCase()
      break
    case 'Base32Lower':
      val = base64ToBase32(cipherData.toString(CryptoJS.enc.Base64)).toLowerCase()
      break
    default:
      val = cipherData.toString(CryptoJS.enc.Base64)
      break
  }
  return val
}
/**
 * @description Base64加密
 * @param value 加密内容
 */
export function encryptBase64(value) {
  return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(value))
}
/**
 * @description HEX加密
 * @param value 加密内容
 */
export function encryptHex(value) {
  const hex = []
  for (let i = 0; i < value.length; i += 1) {
    hex.push(value.charCodeAt(i).toString(16))
  }
  return hex.toString()
}
/**
 * @description Base64加密
 * @param value 加密内容
 */
export default null
